import { create } from 'zustand';
import {
  getEvent, createEvent, getAllEventDates, saveDateVotes,
  getAllVotedEventDates, getDateVoteCounts, getVoteCountPerDateWithName,
  setFinalEventDate, getFinalEventDate, votingFinalEventDate, getIfUserVotedFinalEvent
  , getFinalEventVotesValues, getEventVoteParticipateWithName
} from '../Admin/Api.js';

const useEventStore = create((set, get) => ({
  eventInformation: { headline: "", news: "", template: "default" },
  //event dates voting
  dateInputs: [],
  dateToVote: [], //Datum zur Abstimmung verfügbar { eventDateid, voteDate, voteValue}
  //votedDates: [], //Datum die der User abgestimmt hat { eventDateid, voteValue }
  voteCountsPerDate: [],
  voteCountPerDateWithName: [],
  finalEventDate: "",
  isFinalEventDatePresent: false,
  votingFinalDate: -1,

  //final event voting
  anwesend: 0,
  abwesend: 0,
  voteStatus: -1, // -1 = noch nicht abgestimmt, 0 = abwesend, 1 = anwesend
  checkboxOne: false,
  checkboxTwo: false,
  voteCountParticipateWithName: [],

  //event dates voting
  getEventInformation: async () => {
    getEvent().then((event) => {
      set({ eventInformation: { headline: event.headline, news: event.news, template: event.template || "default" } });
    })
      .catch((error) => {
        console.error("Fehler beim Abrufen der Event-Informationen:", error);
      });
  },
  createEvent: async (eventData) => {
    createEvent(eventData)
      .then(() => {
        set({ eventInformation: { headline: eventData.headline, news: eventData.news, template: eventData.template } });
      })
      .catch((error) => {
        console.error("Fehler beim Erstellen des Events:", error);
      });
  },
  setDateInputs: (inputs) => set({ dateInputs: inputs }),
  //setVotedDates: (votedDates) => set({votedDates: votedDates}),
  getAllEventDates: async () => {
    getAllEventDates()
      .then((data) => {
        //console.log("Event-Daten:", data); // Debugging-Ausgabe
        //set({ dateToVote: data });
      })
      .catch((error) => {
        console.error("Fehler beim Abrufen der Event-Daten:", error);
      })
  },
  getAllEventDatesVoted: async (name) => {
    getAllVotedEventDates(name)
      .then((data) => {
        //geht nicht
        set({ dateToVote: data });
      })
      .catch((error) => {
        console.error("Fehler beim Abrufen der Event-Daten:", error);
      })
  },
  updateDateToVote: (eventDateId, voteDate, voteValue) => {
    set((state) => ({
      dateToVote: state.dateToVote.map(entry =>
        entry.eventDateId === eventDateId
          ? { ...entry, voteValue: voteValue }
          : entry
      )
    }))
  },
  getDateVoteCounts: async () => {
    getDateVoteCounts()
      .then((data) => {
        //console.log("Event-Daten:", data); // Debugging-Ausgabe
        set({ voteCountsPerDate: data });
      })
      .catch((error) => {
        console.error("Fehler beim Abrufen der Event-Daten:", error);
      })
  },
  saveDateVotes: async (name) => {
    const votes = get().dateToVote;
    try {
      const data = await saveDateVotes(votes, name);
      //Call the getDateVoteCounts to update the number on screen
      await get().getDateVoteCounts();
    } catch (error) {
      console.error("Fehler beim Speichern der Daten:", error);
    }
  },
  getVoteCountPerDateWithName: async (name) => {
    getVoteCountPerDateWithName()
      .then((data) => {
        //console.log("show:", data); // Debugging-Ausgabe
        set({ voteCountPerDateWithName: data });
      })
      .catch((error) => {
        console.error("Fehler beim Abrufen der Event-Daten:", error);
      })
  },

  //admin call
  setFinalEventDate: async (event_date_id) => {
    setFinalEventDate(event_date_id)
      .then((data) => {

      })
      .catch((error) => {
        console.error("Fehler beim Abrufen der Event-Daten:", error);
      })
  },

  //final event voting
  getFinalEventDate: async () => {
    getFinalEventDate()
      .then((data) => {
        set({ finalEventDate: data.finalEventDate });
        if (data.present) {
          set({ isFinalEventDatePresent: data.present });
        }
      })
      .catch((error) => {
        console.error("Fehler beim Abrufen der Event-Daten:", error);
      })
  },

  updateFinalEventDateVote: async (username, vote) => {
    const data = await votingFinalEventDate(username, vote)
      .then((data) => {
        //update gui with countValues

        //console.log(data)
      })
      .catch((error) => {
        console.error("Fehler beim Abrufen der Event-Daten:", error);
      })
    get().getFinalEventVotesValues();

  },
  setCheckedOne: (checked) => set({ checkboxOne: checked }),
  setCheckedTwo: (checked) => set({ checkboxTwo: checked }),

  getIfUserVotedFinalEvent: async (name) => {
    getIfUserVotedFinalEvent(name)
      .then((data) => {
        set({ voteStatus: data });
        if (data === 0) {
          set({ checkboxOne: false, checkboxTwo: true });
        }
        if (data === 1) {
          set({ checkboxOne: true, checkboxTwo: false });
        }
        if (data === -1) {
          set({ checkboxOne: false, checkboxTwo: false });
        }
      })
      .catch((error) => {
        console.error("Fehler beim Abrufen des Abstimmungsstatus:", error);
      });
  },

  getFinalEventVotesValues: async () => {
    getFinalEventVotesValues()
      .then((data) => {
        let anwesend = 0;
        let abwesend = 0;

        for (let i = 0; i < data.length; i++) {
          if (data[i] === 1) {
            anwesend++;
          } else {
            abwesend++;
          }
        }
        set({ anwesend: anwesend, abwesend: abwesend });
      })
      .catch((error) => {
        console.error("Fehler beim Abrufen der Anwesenheitsliste:", error);
      });
  },

  getEventVoteParticipateWithName: async (name) => {
    getEventVoteParticipateWithName()
      .then((data) => {
        //console.log("show:", data); // Debugging-Ausgabe
        set({ voteCountParticipateWithName: data });
      })
      .catch((error) => {
        console.error("Fehler beim Abrufen der Event-Daten:", error);
      })
  },
}));

export default useEventStore;